import script from "./TempMode.vue?vue&type=script&setup=true&lang=js"
export * from "./TempMode.vue?vue&type=script&setup=true&lang=js"

import "./TempMode.vue?vue&type=style&index=0&id=0ca84514&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ca84514"]])

export default __exports__